import type { NoddiAsyncError } from 'noddi-types';
import { getFirstErrorCode } from 'noddi-util';

export const NO_SALES_ITEMS_UPCOMING_WHEEL_STORAGE_BOOKING = 'no_sales_items_upcoming_wheel_storage_booking';

/** Catalog empty / blocked outcomes — friendly UI, not operational failures. */
const EXPECTED_INITIAL_AVAILABLE_CODES = new Set([
  'no_sales_items_for_brands_at_address',
  'no_sales_items_at_address',
  'no_sales_items_for_car_rules',
  NO_SALES_ITEMS_UPCOMING_WHEEL_STORAGE_BOOKING,
  'no_sales_items_active_wheel_storage',
  'no_sales_items_wheel_storage_catalog_state',
  'no_sales_items_available_for_car',
  'no_service_departments_available_for_bookings'
]);

export const getInitialAvailableSalesItemsErrorCode = (error: NoddiAsyncError): string | undefined =>
  getFirstErrorCode(error);

/** An empty catalog is a normal answer — say so in an info tone, not a red failure. */
export const isExpectedInitialAvailableSalesItemsOutcome = (error: NoddiAsyncError): boolean => {
  const code = getInitialAvailableSalesItemsErrorCode(error);
  return !!code && EXPECTED_INITIAL_AVAILABLE_CODES.has(code);
};
